import axios from "axios";
import { useContext, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
// import CommonAlert from "../../Commonalert/commonalert";
import { Breadcrumbs, Card, Chip, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { timezonechange, Commonfun, timezoneval } from "../Commonfun";
import BodyCardIcon from "../Asset/esocardicon/VisualValidation/VV_BodyCard.svg"
import MetaCardIcon from "../Asset/esocardicon/VisualValidation/VV_MetaCard.svg"
import ScrollCardIcon from "../Asset/esocardicon/VisualValidation/VV_ScrollCard.svg"
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
// import { timezoneval } from "./Commonfun";
import { ToastContainer, toast } from 'react-toastify';
import { Helmet } from "react-helmet";
import Loader from "../CommonLoader";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import { AppContext } from "../../../Context/Context";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import noImage from "../Asset/download1.png";
import './visualValidation.css';
import Commoncard from "../Commoncard";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";


import UserActivityTracker from "../../../hooks/userActivityTracker";
export default function VisualValidation() {

    const param = useParams();
    const navigate = useNavigate();
    const ticketId = param.id;
    const esodata = useSelector((state) => state);
    const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
    const apiToken = esodata?.apiauthkey?.value;
    const [visualValidData, setVisualValidData] = useState(null);
    const [jobDate, setJobData] = useState(null);
    const [apiopen, setapiOpen] = useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [loading, setLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
    const [jobId, setJobId] = useState("");
    const dropdownRef = useRef();
    const [download, setDownload] = useState(false);
    //faq
    const [faqData, setfaqData] = useState("2")
    const [toggle, setToggle] = useState(false);
    const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
    //run report
    const [isReportOpen, setIsReportOpen] = useState(false);
    const [successApiopen, setSuccessApiOpen] = useState(false);
    const [successApierrorMsg, setSucessApierrorMsg] = useState('');

    useEffect(() => {
        fetchVisualValidData();
        faqdatafun();
    }, []);

    const fetchVisualValidData = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}technical/visual_validation/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=''&timezone=${timezoneval()}`, {
            headers: {
                Authorization: `${apiToken}`,
            }
        }).then((visualData) => {
            console.log('success api', visualData);
            if (visualData.data) {
                console.log('visualData.data', visualData.data);
                setJobData(visualData.data.job_date);
                if (visualData.data?.result && visualData.data?.result?.length > 0) {
                    console.log('visualData.data?.result[0]', visualData.data?.result[0]);
                    setVisualValidData(visualData.data?.result[0]);
                }
            }
        }).catch(error => {
            if (
                error?.response?.status == 599 ||
                error?.response?.status == 400 ||
                error?.response?.status == 500
            ) {
                setapiOpen(true);
                setapierrorMsg(error?.response?.data?.error);
            } else if (
                error?.code == "ERR_NETWORK" ||
                error?.response?.status == 404
            ) {
                navigate("/errorpages");
            }
        })
        setLoading(false);
    }

    const apihandleClose = () => {
        setapiOpen(false);
    }

    const pdfdown = async () => {

        setLoading(true);
        setIsDownloading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}technical/visual_validation/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&timezone=${timezoneval()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    Authorization: `${apiToken}`,
                },
            });

            if (response.ok) {

                const blob = await response.blob();


                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var filedata = await Commonfun("Visualvalidation", "pdf", apiToken, esodata.domaindata.value.header_selected);
                link.download = filedata;
                link.click();


                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error('Error during PDF download:', error);
        }
        setLoading(false);
        setIsDownloading(false);
    }

    const Commoncard = (item, nonclikable) => {

        const cardColors = [
            {
                iconColor: "#ff6600",
                bgColor: "#fff4e6"
            },
            {
                iconColor: "#0b7dda",
                bgColor: "#e6f1ff"
            },
            {
                iconColor: "#7c3aed",
                bgColor: "#f3e8ff"
            },
            {
                iconColor: "#059669",
                bgColor: "#d1fae5"
            }
        ]

        const noCardActivation = !item?.id && !item?.activeValue ? true : false;

        return (
            <>
                <Card onClick={() => item?.handleCardClick ? item?.handleCardClick(item?.route) : null}
                    sx={{
                        borderRadius: "16px",
                        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                        transition: "0.3s",
                        cursor: nonclikable ? "default" : "pointer",
                        height: "100%",
                        // border: 1px solid #e0e0e0;
                        "&:hover": {
                            transform: "translateY(-5px)",
                            boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                        },
                        overflow: "hidden",
                        border: noCardActivation ? "none" : item?.id === item?.activeValue ? "1px solid #ff6600;" : "none"
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: cardColors[item?.bgColor || 1].bgColor,
                            p: 2.5,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 700,
                                fontSize: "20px",
                                background: "linear-gradient(to right, #1f2937, #4b5563)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                                letterSpacing: 1,
                            }}
                        >
                            {item?.value || 0}
                        </Typography>

                        <Box
                            sx={{
                                backgroundColor: cardColors[item?.iconColor || 1].iconColor,
                                color: "#fff",
                                p: 1.5,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "1.5rem",
                            }}
                        >
                            {/* {icon} */}
                            <img src={item?.iconSrc} className="card-icon-img" />
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            background: "#fff",
                            px: 2.5,
                            py: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            textTransform: "uppercase",
                        }}
                    >
                        <Typography
                            sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                        >
                            {item?.title || ""}
                        </Typography>
                        {item?.badge &&
                            <Chip
                                label={item?.badge || ""}
                                size="small"
                                sx={{
                                    backgroundColor: cardColors[item?.iconColor || 1].iconColor,
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "0.7rem",
                                    borderRadius: "9999px",
                                    px: 1,
                                }}
                            />
                        }
                    </Box>
                </Card>
            </>
        )
    }

    const cardDatas = [
        {
            value: "Scroll Bar",
            title: <span className="vv-scrollbar-card">
                {visualValidData?.metadata?.chrome?.scrollbar?.vertical_scrollbar ?
                    <div>Vertical: <CheckIcon className="visual-valid-icon" /></div> :
                    <div>Vertical: <ClearIcon className="visual-invalid-icon" /></div>}
                {visualValidData?.metadata?.chrome?.scrollbar?.horizontal_scrollbar ?
                    <div>Horizontal: <CheckIcon className="visual-valid-icon" /></div> :
                    <div>Horizontal: <ClearIcon className="visual-invalid-icon" /></div>}
            </span>,
            // title: <CheckIcon className="visual-valid-icon" />,
            // badge: "SEO",
            iconSrc: ScrollCardIcon,
            iconColor: 1,
            bgColor: 1,

        },
        {
            value: "Body vs Viewport",
            title: visualValidData?.metadata?.chrome?.viewport ?
                visualValidData?.metadata?.chrome?.viewport?.body_width + ' x ' + visualValidData?.metadata?.chrome?.viewport?.body_height + ' Vs ' + visualValidData?.metadata?.chrome?.viewport?.viewport_width + ' x ' + visualValidData?.metadata?.chrome?.viewport?.viewport_height : '-',
            // badge: "TRAFFIC",
            iconSrc: BodyCardIcon,
            iconColor: 2,
            bgColor: 2,
        },
        {
            value: "Meta Viewport",
            title: visualValidData?.metadata?.chrome?.meta_viewport ? <span>Found <CheckIcon className="visual-valid-icon" /></span> : <span>Not Found <ClearIcon className="visual-invalid-icon" /></span>,
            // badge: "TRAFFIC",
            iconSrc: MetaCardIcon,
            iconColor: 3,
            bgColor: 3,
        },

    ];

    const handleToggle = () => {
        if (faqData != 1) {
            setfaqData(1)
        }
        else {
            setfaqData(2)
        }
        setToggle((pre) => !pre);
    };

    const faqdatafun = async (menubutval = "") => {
        var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=79`

        try {
            const doaminsectiondatavalue = await axios.get(
                datavar,
                {
                    headers: {
                        Authorization: `${apiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });
            if (doaminsectiondatavalue?.data) {
                SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
            }
        } catch (err) { }
    }

    //Run report

    const closeRunReport = () => {
        setIsReportOpen(false);
    }

    const runReportNow = async () => {
        setLoading(true);

        const datavalue = await axios.get(
            `${process.env.REACT_APP_API_URL}domain/create_new_job_as_user/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=visual_validation`, {
            headers: {
                Authorization: `${apiToken}`,
            },
        }
        ).catch((error) => {
            if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                setapiOpen(true);
                setapierrorMsg(error?.response?.data?.error)
            }
            else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                navigate('/errorpages')
            }
        });
        if (datavalue?.status === 200) {
            setSuccessApiOpen(true);
            setSucessApierrorMsg(datavalue?.data?.message);
        }

        setIsReportOpen(false);
        setLoading(false);
    };

    const successApiClose = () => {
        setSuccessApiOpen(false);
    }



    return (
        <><ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Visual Validation</title>
            </Helmet>
            {loading === true ? <Loader /> : null}
            <div className={`over_all_container over_all_accessibility ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
                <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={4}>
                                <div>
                                    <h1 className="dashboard_header">
                                        Visual Validation
                                        <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                                    </h1>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <div className="top_breadcrumb_menu">
                                    <div className="exportpdf_outer">
                                        <div className="breadcrumb-wrapper">
                                            <CommonBreadCrumb breadcrumbValue={[
                                                { title: 'Technical', active: true },
                                                { title: 'Visual Validation', active: true }
                                            ]} />
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box-time">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={6}>
                                <div className="time_zone">
                                    <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                                    <span className="timezone-val">{timezoneval()}</span>
                                </div>
                            </Grid>

                            <Grid item xs={12} md={6}>

                                <div style={{ display: "flex", gap: "16px", alignItems: "center", justifyContent: "end", marginRight: "13px" }}>
                                    <button
                                        title="Run Report"
                                        className="btn_dashboard"
                                        onClick={() => setIsReportOpen(true)}
                                    // onClick={() => {
                                    //   if (first.statusDomain) {
                                    //     setcheckD(first.statusDomain);
                                    //   } else {

                                    //     setfaqData(2);
                                    //     setToggle(false);
                                    //     SetRunReportPopShow(true);
                                    //   }
                                    // }}
                                    // disabled={!analysisSummaryPlan.status}
                                    >
                                        Run Report Now
                                    </button>
                                    <button
                                        className="dashboard_download"
                                        onClick={() => pdfdown()}
                                    >
                                        Download PDF{" "}
                                        <svg
                                            className="filter"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7 10 12 15 17 10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                        </svg>
                                    </button>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="dashboard-card-container">
                    <Box >
                        <Grid container className="dashboard-box-card">
                            <Grid container spacing={3} justifyContent="center">
                                {cardDatas.map((item, index) => (
                                    <Grid item xs={12} sm={6} md={3} key={item.id}>
                                        {Commoncard(item, true)}
                                        {/* <Commoncard
                                                item={item}
                                                nonclikable={true}
                                            /> */}
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="dashboard-card-container">
                    <Box className="dashboard-box-card">
                        <Grid container className="dashboard-card-grid">
                            <Grid item xs={12} md={12}>
                                {visualValidData &&
                                    <div className="visual-valid-card-container">
                                        <div className="visual-valid-card">
                                            <img className="visual-valid-img" src={visualValidData.chrome_image || noImage} alt="browser-img" />
                                            <div>
                                                <div>
                                                    <span className="visual-valid-label">Browser Name:</span>
                                                    {visualValidData?.metadata?.chrome?.browser_name || '-'}
                                                </div>
                                                <div>
                                                    <span className="visual-valid-label">Version:</span>
                                                    {visualValidData?.metadata?.chrome?.browser_version || '-'}
                                                </div>
                                                <div>
                                                    <span className="visual-valid-label">Cookie Count:</span>
                                                    {visualValidData?.metadata?.chrome?.cookies_count || '-'}
                                                </div>
                                                <div>
                                                    <span className="visual-valid-label">Session Count:</span>
                                                    {visualValidData?.metadata?.chrome?.session_storage_count || '-'}
                                                </div>
                                                <div>
                                                    <span className="visual-valid-label">Local Storage Count:</span>
                                                    {visualValidData?.metadata?.chrome?.local_storage_count || '-'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="visual-valid-card">
                                            <img className="visual-valid-img" src={visualValidData.firefox_image || noImage} alt="browser-img" />
                                            <div>
                                                <div><span className="visual-valid-label">Browser Name:</span> {visualValidData?.metadata?.firefox?.browser_name || '-'}</div>
                                                <div><span className="visual-valid-label">Version:</span> {visualValidData?.metadata?.firefox?.browser_version || '-'}</div>
                                                <div>
                                                    <span className="visual-valid-label">Cookie Count:</span>
                                                    {visualValidData?.metadata?.chrome?.cookies_count || '-'}
                                                </div>
                                                <div><span className="visual-valid-label">Session Count:</span> {visualValidData?.metadata?.firefox?.session_storage_count || '-'}</div>
                                                <div><span className="visual-valid-label">Local Storage Count:</span> {visualValidData?.metadata?.firefox?.local_storage_count || '-'}</div>
                                            </div>
                                        </div>
                                        <div className="visual-valid-card">
                                            <img className="visual-valid-img" src={visualValidData.webkit_image || noImage} alt="browser-img" />
                                            <div>
                                                <div><span className="visual-valid-label">Browser Name:</span> {visualValidData?.metadata?.webkit?.browser_name || '-'}</div>
                                                <div><span className="visual-valid-label">Version:</span> {visualValidData?.metadata?.webkit?.browser_version || '-'}</div>
                                                <div>
                                                    <span className="visual-valid-label">Cookie Count:</span>
                                                    {visualValidData?.metadata?.chrome?.cookies_count || '-'}
                                                </div>
                                                <div><span className="visual-valid-label">Session Count:</span> {visualValidData?.metadata?.webkit?.session_storage_count || '-'}</div>
                                                <div><span className="visual-valid-label">Local Storage Count:</span> {visualValidData?.metadata?.webkit?.local_storage_count || '-'}</div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="footer-container">
                    <Box className="footer-box">
                        <Grid container className="footer-grid">
                            <Grid item xs={12} md={6}>
                                <div className="footer-left">
                                    <p className="footer-text">
                                        All Rights Reserved Copyright © 2026 |
                                        <a href="https://www.egrovesys.com/" target="blank">
                                            <span className="footer-brand"> Elite site Optimizer</span>
                                        </a>
                                    </p>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className="footer-right">
                                    <p>{/* Add content if needed */}</p>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <div className="cnt_audit_outer_wrap">
                    <div >
                        {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
                    </div>
                </div>

                <Dialog
                    open={isReportOpen}
                    onClose={closeRunReport}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className="competitor_test_filter job_date_filter over_all_accessibility"
                >
                    <DialogTitle className="keyword-dialog-header ">
                        {"Run Report"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            <div>
                                Can we run the report for Visual Validation ?
                            </div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="dialog-action-button">
                        <button
                            className="form_submit_btn"
                            onClick={runReportNow}
                            style={{ cursor: "pointer" }}
                        >
                            Run
                        </button>
                        <button style={{ cursor: "pointer" }} onClick={closeRunReport}>
                            Cancel
                        </button>
                    </DialogActions>
                </Dialog>

                <CommonErrorAlert
                    data={{
                        apiopen: successApiopen,
                        apiErrorMsg: successApierrorMsg,
                        isIconStyled: false
                    }}
                    closeAlert={successApiClose} />


                <CommonErrorAlert
                    data={{
                        apiopen: apiopen,
                        apiErrorMsg: apierrorMsg,
                        isIconStyled: true
                    }}
                    closeAlert={apihandleClose}
                />
                 
                   <UserActivityTracker pagename="Technical - Visual Validation" />
            </div>
        </>
    )
}